import { SVGProps } from 'react';

const SvgSnooze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h59.1l-77.2 88.2c-6.2 7.1-7.7 17.1-3.8 25.7S174.6 176 184 176h112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-59.1l77.2-88.2c6.2-7.1 7.7-17.1 3.8-25.7S305.4 0 296 0H184zm128 224c-13.3 0-24 10.7-24 24s10.7 24 24 24h62.9l-81.8 105.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-62.9L443 262.8c5.6-7.2 6.6-17 2.6-25.3S433.2 224 424 224H312zm-288 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h128.6L4.6 473.8c-5.3 7.3-6.1 17-2.1 25S15 512 24 512h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H71.4l148-201.8c5.3-7.3 6.1-17 2.1-25S209 224 200 224H24z" />
  </svg>
);
export default SvgSnooze;
